/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ window: NonNullable<unknown> }} Measure_Response_MedianInputs */

const en_measure_response_median = /** @type {(inputs: Measure_Response_MedianInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`median · ${i?.window}`)
};

const zh_hans1_measure_response_median = /** @type {(inputs: Measure_Response_MedianInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`中位数 · ${i?.window}`)
};

const pt_br2_measure_response_median = /** @type {(inputs: Measure_Response_MedianInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`mediana · ${i?.window}`)
};

const es_measure_response_median = /** @type {(inputs: Measure_Response_MedianInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`mediana · ${i?.window}`)
};

const fr_measure_response_median = /** @type {(inputs: Measure_Response_MedianInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`médiane · ${i?.window}`)
};

const de_measure_response_median = /** @type {(inputs: Measure_Response_MedianInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Median · ${i?.window}`)
};

const ru_measure_response_median = /** @type {(inputs: Measure_Response_MedianInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`медиана · ${i?.window}`)
};

const it_measure_response_median = /** @type {(inputs: Measure_Response_MedianInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`mediana · ${i?.window}`)
};

/**
* | output |
* | --- |
* | "median · {window}" |
*
* @param {Measure_Response_MedianInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const measure_response_median = /** @type {((inputs: Measure_Response_MedianInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Measure_Response_MedianInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_measure_response_median(inputs)
	if (locale === "pt-BR") return pt_br2_measure_response_median(inputs)
	if (locale === "es") return es_measure_response_median(inputs)
	if (locale === "fr") return fr_measure_response_median(inputs)
	if (locale === "de") return de_measure_response_median(inputs)
	if (locale === "ru") return ru_measure_response_median(inputs)
	if (locale === "it") return it_measure_response_median(inputs)
	return en_measure_response_median(inputs)
});